import { FC, useCallback, useEffect, useState } from 'react'
import css from './index.module.less'
import { useParams } from 'react-router-dom'
import { useTranslation } from "react-i18next";
import { Button, Image } from 'antd-mobile'
import usefulIcon from '@img/useful.png';
import usefulActiveIcon from '@img/useful-active.png';
import uselessIcon from '@img/useless.png';
import uselessActiveIcon from '@img/useless-active.png';
import { actionTypes, useStoreDispatch, useStoreState } from '@/store'
import { getCateListApi, getQuestionDetailApi, setQuestionStatApi } from '@/api/home'
import { PageLoading } from '@/components/PageLoading'
import { getLngToApi } from '@/utils/getLng'

export const QuestionDetail: FC = props => {
  const { t } = useTranslation();
  const { id } = useParams();
  const [detail, setDetail] = useState<any>({});
  const dispatch = useStoreDispatch()
  const { pageLoading } = useStoreState()

  // 初始化获取分类列表
  useEffect(() => {
    const getDetail = async () => {
      dispatch({ type: actionTypes.SET_PAGE_LOADING, payload: true })
      const res = await getQuestionDetailApi({ id, language: getLngToApi() }).finally(() => dispatch({ type: actionTypes.SET_PAGE_LOADING, payload: false }))
      if (res?.code === 0) {
        setDetail(res.data)
      }
    }
    getDetail();
  }, [])

  const updateStat = async (statType) => {
    if (detail.stat === statType) return;
    const res = await setQuestionStatApi({ id, statType })
    if (res?.code === 0) {
      setDetail(prevState => ({ ...prevState, stat: statType }))
    }
  }


  if (pageLoading) return <PageLoading />;

  return (
    <div className={css.Page}>

      <div className={css.PageHd}>{detail.title}</div>

      <div className={css.PageBd} dangerouslySetInnerHTML={{ __html: detail.answer }}></div>

      <div className={css.PageFt}>
        <div className={css.FtHd}>{t('question.feedback-title')}</div>
        <div className={css.FtBd}>
          <Button
            className={`${css.FtBtn} ${detail.stat === statMap.useful && css.active}`} shape='rounded'
            // disabled={detail.stat === statMap.useful}
            onClick={() => updateStat(statMap.useful)}
            loading={'auto'}
          >
            <Image src={detail.stat === statMap.useful ? usefulActiveIcon : usefulIcon} /><span>{t('question.feedback-1')}</span>
          </Button>
          <Button
            className={`${css.FtBtn} ${detail.stat === statMap.useless && css.active}`} shape='rounded'
            // disabled={detail.stat === statMap.useless}
            onClick={() => updateStat(statMap.useless)}
            loading={'auto'}
          >
            <Image src={detail.stat === 0 ? uselessActiveIcon : uselessIcon} /><span>{t('question.feedback-2')}</span>
          </Button>
        </div>
      </div>

    </div>
  )
}

// 状态映射
const statMap = {
  useful: 1,
  useless: 0,
}
